import { computed, onBeforeMount, onUnmounted, ref } from 'vue'

import { useClient } from './useClient'


export const useBrowserResize = () => {
  const { isClient } = useClient()
  const innerWidth = ref(isClient.value ? window.innerWidth : 0)
  const innerHeight = ref(isClient.value ? window.innerHeight : 0)

  const handlerList = ref<(() => void)[]>([])
  const setResizeHandler = (handler: () => void) => {
    handlerList.value.push(handler)
  }

  const isXs = computed(() => innerWidth.value < 600)
  const isMn = computed(() => innerWidth.value < 840)
  // TODO 이름 통일을 위한 재정의, 하나로 통합 필요
  const isMobile = computed(() => innerWidth.value < 840)
  const isMd = computed(() => innerWidth.value < 1200)
  const isSm = computed(() => innerWidth.value < 960)
  const isSxga = computed(() => innerWidth.value < 1280)
  const isFhd = computed(() => innerWidth.value < 1920)

  function handleResize() {
    innerWidth.value = window.innerWidth
    innerHeight.value = window.innerHeight
    handlerList.value.map(handler => {
      handler()
    })
  }

  onBeforeMount(() => {
    window.addEventListener('resize', handleResize)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', handleResize)
  })
  return {
    innerWidth,
    innerHeight,
    isXs,
    isMd,
    isMn,
    isSm,
    isSxga,
    isFhd,
    isMobile,
    setResizeHandler,
  }
}
